<div *ngIf="display">
	<button class="testMailButton" [style.color]="testMailActive ? null : 'red'" (click)="onEnvelopeClick()">
		<i class="fa fa-lg fa-envelope fa-fw" ></i>
	</button>
</div>